<div class="sidebar" [class.sidebar_expanded]="!isCollapsed" [class.sidebar_collapsed]="isCollapsed">
  <header class="sidebar-header">
    <img src="assets/images/logo-white.svg" alt="SipSignal Efax Logo" class="sidebar-header-logo" />
    <img src="assets/images/logo-white-mini.svg" alt="SipSignal Efax Logo" class="sidebar-header-logo-mini" />
  </header>

  <nav class="sidebar-nav">
    <a
      *ngFor="let item of navList"
      [routerLink]="item.routerLink"
      class="sidebar-nav-link"
      [class.sidebar-nav-link_active]="isCurrentUrlEquals(item.routerLink)"
    >
      <img [src]="getIconSrc(item)" alt="" class="sidebar-icon" />
      <span class="sidebar-text">{{ item.label }}</span>
    </a>
  </nav>

  <div class="sidebar-additional-nav">
    <a href="https://uisp.bpnetworking.com/crm/login" target="_blank" rel="noreferrer" class="sidebar-nav-link">
      <img src="assets/icons/nav/support.svg" alt="" class="sidebar-icon" />
      <span class="sidebar-text">Support</span>
    </a>

    <button class="sidebar-nav-link" (click)="signOut()">
      <img src="assets/icons/nav/exit.svg" alt="" class="sidebar-icon" />
      <span class="sidebar-text">Exit</span>
    </button>
  </div>

  <footer class="sidebar-footer">
    <p class="sidebar-app-version sidebar-text">Version {{ appVersion }}</p>

    <button class="sidebar-expand-button" (click)="toggleCollapsed()">
      <img src="assets/icons/chevron-left.svg" alt="Expand/Collapse" class="sidebar-expand-icon" />
    </button>
  </footer>
</div>
